export const MAPS_LIMIT = 30
export const SAMPLE_MAP_URL =
  'https://mapstack-prod-public-resources.s3.amazonaws.com/sample-data/us-counties.geojson'
